module.exports = __webpack_public_path__ + "img/lol-logo.ed5c0114.svg";